import { useParams, Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { SplitFeature } from "@/components/sections"
import { ProductHero, ProductDescription, ProductAdvantages, ProductConditions, ProductCTA } from "@/components/sections/product"
import { PageMeta } from "@/components/shared/PageMeta"
import PRODUCTS, { isBaseProduct, type ProductType } from "@/content/products"
import { getProductContent } from "@/content/products-content"
import { family } from "@/content/home"
import { productOgImagePath } from "@/lib/seo"

export default function ProductoDetailPage(): React.JSX.Element {
	const { slug } = useParams<{ slug: string }>()

	if (!slug || !isBaseProduct(slug)) {
		return (
			<>
				<PageMeta
					title="Producto no encontrado"
					description="El producto que buscas no existe o ya no está disponible."
					path={`/productos/${slug ?? ""}`}
				/>
				<div className="mx-auto max-w-3xl px-4 py-20 text-center">
					<p className="text-lg text-muted-foreground">Producto no encontrado.</p>
					<Button asChild className="mt-6">
						<Link to="/productos">Volver a productos</Link>
					</Button>
				</div>
			</>
		)
	}

	const product = PRODUCTS[slug as ProductType]
	const content = getProductContent(product.id)
	const description = content.slogan ?? product.title

	return (
		<>
			<PageMeta
				title={product.name}
				description={description}
				image={productOgImagePath(product.id)}
				path={`/productos/${slug}`}
			/>
			<ProductHero product={product} content={content} />
			<ProductDescription blocks={content.description} />
			<ProductAdvantages advantages={content.advantages} />
			<SplitFeature title={family.title} body={family.body} backgroundImage={family.backgroundImage} padTop />
			<ProductConditions productId={product.id} name={product.name} />
			<ProductCTA item={product} cta={content.cta} />
		</>
	)
}
